import { types } from 'mobx-state-tree';

const OrderPaymentProvider = {
  KUSTOM: 'KUSTOM',
  PAYTRAIL: 'PAYTRAIL',
  VERIFONE: 'VERIFONE',
};

export default OrderPaymentProvider;

export const OrderPaymentProviderType = types.enumeration(
  'OrderPaymentProviderType',
  Object.values(OrderPaymentProvider)
);
